import { CardWithC4CssProps } from './CssConfig';

export const requisitionsConfigs = [
  {
    componentReference: 'title',
    label: 'Requisitions',
    id: 'requisitions-holder',
    cssProps: {
      width: '100%',
      display: 'block',
    },
  },
  // cards
  {
    componentReference: 'container',
    id: 'requisitions-cards-container',
    children: [
      {
        containerType: 'requisitions',
        componentType: 'card',
        componentReference: 'card',
        id: 'requisitions_opened',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'requisitions_opened',
          id: 'requisitions_opened',
          value: 400,
          topLabel: 'Requisitions opened',
          bottomLabel: 'REQUISITIONS',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'requisitions_opened',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'requisitions_opened',
            id: 'requisitions_opened',
          },
        },
      },
      {
        containerType: 'requisitions',
        componentType: 'card',
        componentReference: 'card',
        id: 'requisitions_filled',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'requisitions_filled',
          id: 'requisitions_filled',
          value: 350,
          topLabel: 'Requisitions filled',
          bottomLabel: 'REQUISITIONS',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'requisitions_filled',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'requisitions_filled',
            id: 'requisitions_filled',
          },
        },
      },
      {
        containerType: 'requisitions',
        componentType: 'card',
        componentReference: 'card',
        id: 'requisitions_closed',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'requisitions_closed',
          id: 'requisitions_closed',
          value: 220,
          topLabel: 'Requisitions closed',
          bottomLabel: 'REQUISITIONS',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'requisitions_closed',
            componentType: 'card',
            apiParam: 'card',
            headerKey: 'requisitions_closed',
            id: 'requisitions_closed',
          },
        },
      },
      {
        containerType: 'requisitions',
        componentType: 'card',
        componentReference: 'card',
        id: 'total_time_to_fill',
        selected: false,
        cssProps: CardWithC4CssProps,
        ui: {
          renderType: 'card',
          header: 'total_time_to_fill',
          id: 'total_time_to_fill',
          value: '2 days',
          topLabel: 'Avg. time to fill',
          bottomLabel: 'TIME',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'total_time_to_fill',
            id: 'total_time_to_fill',
            componentType: 'card',
            calculationType: 'avgChange',
            apiParam: 'card',
            unit: 'time',
            metricKeys: {
              numerator: 'total_time_to_fill',
              denominator: 'requisitions_filled',
            },
          },
        },
      },
    ],
  },
  // trend chart
  {
    containerType: 'requisitions',
    componentType: 'chart',
    componentReference: 'chart',
    id: 'requisitions_trend_chart',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Trend of requisitions opened',
      id: 'requisitions_trend_chart',
      chartData: {
        categories: ['2023-Q4', '2024-Q1', '2024-Q2', '2024-Q3', '2024-Q4'],
        series: [0, 0, 0, 27, 13],
      },
      chartType: 'area',
    },
    api: {
      subject_type: 'requisitions',
      metadata: {
        tileKey: 'requisitions_trend_chart',
        componentType: 'chart',
        apiParam: 'chart_table',
        headerKeys: [],
        id: 'requisitions_trend_chart',
      },
    },
  },
  // chart 1 & Chart 2
  {
    componentReference: 'container',
    id: 'requisitions-chart-container2',
    children: [
      {
        containerType: 'requisitions',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'requisitions_by_department',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Requisitions by department ',
          id: 'requisitions_by_department',
          chartData: {
            categories: [
              'Engineering',
              'Design',
              'Product',
              'Sales',
              'QA',
              'CX',
              'Marketing',
            ],
            series: [290, 170, 100, 185, 143, 20, 10],
          },
          chartType: 'bar',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'requisitions_by_department',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'department',
            },
            headerKeys: [],
            id: 'requisitions_by_department',
          },
        },
      },
      {
        containerType: 'requisitions',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'requisitions_by_requisition_type',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Requisitions by requisition type',
          id: 'requisitions_by_requisition_type',
          chartData: {
            categories: ['New hire', 'Black fill', 'Internal'],
            series: [234, 88, 4, 3, 74, 106],
          },
          chartType: 'bar',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'requisitions_by_requisition_type',
            componentType: 'chart',
            apiParam: 'visual',
            defaultFilters: {
              group_by_1: 'requisition_type',
            },
            headerKeys: [],
            id: 'requisitions_by_requisition_type',
          },
        },
      },
    ],
  },
  //pie chart
  {
    componentReference: 'container',
    id: 'requisitions-chart-container1',
    children: [
      {
        containerType: 'requisitions',
        componentType: 'chart',
        componentReference: 'chart',
        id: 'requisitions_by_department_pie',
        selected: false,
        cssProps: {
          width: '50%',
          display: 'block',
        },
        ui: {
          title: 'Percentage of requisitions filled by department',
          id: 'requisitions_by_department_pie',
          chartData: {
            series: [
              {
                name: 'Engineering',
                y: 290,
              },
              {
                name: 'Design',
                y: 170,
              },
              {
                name: 'Product',
                y: 100,
              },
              {
                name: 'Sales',
                y: 185,
              },
              {
                name: 'QA',
                y: 143,
              },
              {
                name: 'CX',
                y: 20,
              },
              {
                name: 'Marketing',
                y: 10,
              },
            ],
          },
          chartType: 'pie',
        },
        api: {
          subject_type: 'requisitions',
          metadata: {
            tileKey: 'requisitions_by_department_pie',
            componentType: 'chart',
            apiParam: 'chart_table',
            defaultFilters: {
              group_by_1: 'department',
            },
            headerKeys: [],
            id: 'requisitions_by_department_pie',
          },
        },
      },
    ],
  },
  {
    containerType: 'requisitions',
    componentType: 'table',
    componentReference: 'table',
    id: 'requisitions_table',
    selected: false,
    cssProps: {
      width: '100%',
      display: 'block',
    },
    ui: {
      title: 'Requisition breakdown',
      id: 'requisitions_table',
      tableData: [
        {
          ds: '0',
          dt: '2023-Q4',
          header: '2023-Q4',
          g1: null,
          g2: null,
          requisitions_opened: 922,
          requisitions_opened_total: 4944,
          requisitions_closed: 798,
          requisitions_closed_total: 5526,
          time_to_fill: 1000000,
          requisitions_filled: 10,
          requisitions_filled_total: 100,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q1',
          header: '2024-Q1',
          g1: null,
          g2: null,
          requisitions_opened: 2922,
          requisitions_opened_total: 4944,
          requisitions_closed: 2798,
          requisitions_closed_total: 5526,
          time_to_fill: 123456,
          requisitions_filled: 10,
          requisitions_filled_total: 100,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q2',
          header: '2024-Q2',
          g1: null,
          g2: null,
          requisitions_opened: 1000,
          requisitions_opened_total: 4944,
          requisitions_closed: 900,
          requisitions_closed_total: 5526,
          time_to_fill: 986712,
          requisitions_filled: 30,
          requisitions_filled_total: 100,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q3',
          header: '2024-Q3',
          g1: null,
          g2: null,
          requisitions_opened: 100,
          requisitions_opened_total: 4944,
          requisitions_closed: 940,
          requisitions_closed_total: 5526,
          time_to_fill: 123112,
          requisitions_filled: 30,
          requisitions_filled_total: 100,
          subRows: [],
        },
        {
          ds: '0',
          dt: '2024-Q4',
          header: '2024-Q4',
          g1: null,
          g2: null,
          requisitions_opened: 0,
          requisitions_opened_total: 4944,
          requisitions_closed: 90,
          requisitions_closed_total: 5526,
          time_to_fill: 897312,
          requisitions_filled: 20,
          requisitions_filled_total: 100,
          subRows: [],
        },
      ],
    },
    api: {
      subject_type: 'requisitions',
      metadata: {
        tileKey: 'requisitions_table',
        componentType: 'table',
        apiParam: 'chart_table',
        headerKeys: [
          'requisitions_opened',
          'requisitions_closed',
          'time_to_fill',
        ],
        id: 'requisitions_table',
      },
    },
  },
];
